import React from 'react'

const ListItemIcon = function ListItemIcon(props) {
    return (
        <div className={'listitemicon'}  onClick={(ev)=>{if (props.onClick) {ev.stopPropagation();props.onClick()}}}>{props.children}</div>
    )
}

export { ListItemIcon };
